"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LINK_LIST_TITLE = exports.LINK_LIST_ROOT = exports.LINK_LIST_LINK_ICON = exports.LINK_LIST_LAYOUT_NAME = exports.LINK_LIST_ITEM_TITLE = exports.LINK_LIST_ITEM_LINK = exports.LINK_LIST_DOWNLOAD_ICON = void 0;
const LINK_LIST_LAYOUT_NAME = exports.LINK_LIST_LAYOUT_NAME = 'EditorialLinkList';
const LINK_LIST_ROOT = exports.LINK_LIST_ROOT = 'link-list-root';
const LINK_LIST_TITLE = exports.LINK_LIST_TITLE = 'link-list-title';
const LINK_LIST_DOWNLOAD_ICON = exports.LINK_LIST_DOWNLOAD_ICON = 'link-list-download-icon';
const LINK_LIST_LINK_ICON = exports.LINK_LIST_LINK_ICON = 'link-list-link-icon';
const LINK_LIST_ITEM_TITLE = exports.LINK_LIST_ITEM_TITLE = 'link-list-item-title';
const LINK_LIST_ITEM_LINK = exports.LINK_LIST_ITEM_LINK = 'link-list-item-link';
